module.exports = __webpack_public_path__ + "static/img/1_1_5.929ec1c2.jpg";